import { formatToLocaleString } from "Formatting/formatNumber";
import { SopSicknessLeaveProduct } from "Store/interfaces/products/checkout/lifeProducts/SopSicknessLeaveProduct";
import { ProductDetail } from "../../interface";

export const sopSicknessLeaveDetailsList = (
  product: SopSicknessLeaveProduct,
  types: any,
  lang: string,
): ProductDetail[] => {
  return [
    {
      name: "revenue",
      value: formatToLocaleString(product.revenue),
    },
    {
      name: "waitingPeriodBeforePayoutStarts",
      value: `${product.waitingPeriodBeforePayoutStarts} ${types.waitingPeriodUnit[lang]}`,
    },
  ];
};
